// eslint-disable-next-line no-restricted-imports
import {useChatState} from '@github-ui/copilot-chat/CopilotChatContext'

import type {DraftIssue} from '../content-preview-types'

export function useUserEditedNewIssueId(draftIssue: DraftIssue): DraftIssue['id'] {
  const {messages} = useChatState()
  const {tag, issueNumber} = draftIssue
  const type = issueNumber ? 'update-issue' : 'new-issue'
  return `${type}:${tag}#${messages.length}` // messages.length represents the next user message index
}
